'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var mainTableClass = {
    borderCollapse: 'collapse',
    width: '100%'
};
var containerClass = function containerClass(container) {
    return {
        backgroundColor: container.backgroundColor,
        color: container.color,
        fontSize: container.fontSize,
        fontWeight: container.fontWeight,
        fontStyle: container.fontStyle,
        textDecoration: container.textDecoration,
        fontFamily: container.fontFamily
    };
};

exports.default = {
    mainTableClass: mainTableClass,
    containerClass: containerClass
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/constants/defaultClasses.js
// module id = 69
// module chunks = 0